import { useEffect, useState } from "react";
import { formatET } from "../../lib/dateUtils";

function formatDuration(seconds) {
  if (seconds == null) return "0m";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export function RepSessionClock({ session, testId }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!session?.active) return;
    const loginAt = new Date(session.login_at).getTime();
    const tick = () => setElapsed(Math.floor((Date.now() - loginAt) / 1000));
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [session?.active, session?.login_at]);

  if (!session) {
    return <p className="text-igc-muted text-[11px]" data-testid={testId}>Not logged in yet today</p>;
  }

  if (session.active) {
    return (
      <div className="flex items-center justify-between text-[11px]" data-testid={testId}>
        <span className="text-igc-success flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-igc-success animate-pulse shrink-0" /> Online since {formatET(session.login_at, "h:mm a")}
        </span>
        <span className="text-igc-goldText font-medium tabular-nums">{formatDuration(elapsed)}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between text-[11px]" data-testid={testId}>
      <span className="text-igc-muted">Logged off {formatET(session.logout_at, "h:mm a")}</span>
      <span className="text-igc-cream font-medium tabular-nums">{formatDuration(session.duration_seconds)}</span>
    </div>
  );
}
